import {HyperDropComponent} from "./HyperDropComponent";
import {HyperDropAccordion} from "./HyperDropAccordion";

export class HyperDropAccordionList extends HyperDropComponent {


  accordions: HyperDropAccordion[];
  closeOthers: boolean = false;
  onMount(): void {
    this.accordions = [];
    for(const accordionElement of this.elements.accordions) {
      const accordion = new HyperDropAccordion({
        elements: {
          accordion: accordionElement
        }
      });
      this.accordions.push(accordion);
      accordion.elements.accordion.addEventListener('accordion:open', this.accordionOpened.bind(this));
    }
  }
  private accordionOpened(event: CustomEvent) {
    if(!this.closeOthers) return;
    for(const accordion of this.accordions) {
      if(accordion !== event.detail.accordion && accordion.isOpen) {
        accordion.close();
      }
    }
  }
}
